import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=3d54a24a"
import script from "./PreviewImage.vue?vue&type=script&lang=js"
export * from "./PreviewImage.vue?vue&type=script&lang=js"
import style0 from "./PreviewImage.vue?vue&type=style&index=0&id=3d54a24a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports